<template>
  <component
    :is="dialog ? 'q-dialog' : 'div'"
    v-if="shown"
    v-model="shown"
    :maximized="maximized"
  >
    <q-card
      class="membership-action-buttons bg-responsive overflow-hidden"
      flat
      bordered
    >
      <slot name="header" />
      <q-list
        class="q-ma-md border-responsive-grey-1"
        bordered
        separator
      >
        <q-item
          v-for="member in currentUser.membership.members.data"
          :key="member.id"
          class="q-px-md"
          :class="(member.membershipType.name || member.userClass.name) ? 'q-py-md' : 'q-py-lg'"
        >
          <q-item-section class="text-left">
            <q-item-label class="text-body1 text-bold">
              {{ member.name }}
              <q-badge
                v-if="currentUser.membership.members.data.length > 1 && (member.id === currentUser.membership.owner.id)"
                color="primary"
                :text-color="$isColorDark(currentSite.primaryColor) ? 'white': 'dark'"
              >
                {{ $t('common.owner') }}
              </q-badge>
            </q-item-label>
            <q-item-label
              v-if="member.membershipType.name || member.userClass.name"
              caption
            >
              {{ member.membershipType.name }}
              <template v-if="member.membershipType.name && member.userClass.name">
                -
              </template>
              {{ member.userClass.name }}
            </q-item-label>
          </q-item-section>
          <q-item-section
            side
            class="text-body2 text-right"
          >
            <span>
              <i18n-n
                :value="memberRateDisplayTotal(member)"
                format="currency"
              />
              / {{ member.membership.termName }}
            </span>
          </q-item-section>
        </q-item>
      </q-list>
      <q-card-actions
        v-if="showActionButton"
        align="center"
        class="q-mb-md"
      >
        <q-btn
          class="q-mx-sm"
          style="width: 100%;"
          size="md"
          outline
          rounded
          color="primary"
          :label="$tc('membership.actions.manageMember', 2)"
          to="checkout/modify-membership"
        />
      </q-card-actions>
    </q-card>
  </component>
</template>
<script>

export default {
  name: 'ManageMembers',
  context: ['currentUser'],
  configuration: ['currentCircuit', 'membershipTypes', 'currentSite'],
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false
    },
    maximized: {
      type: Boolean,
      required: false,
      default: true
    },
    showActionButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      shown: !this.dialog
    }
  },
  computed: {
    membershipPeriod () {
      return this.currentUser?.membership?.term || this.currentCircuit.membershipRateDisplayPeriod || 1
    }
  },
  methods: {
    hide () {
      this.shown = false
    },
    show () {
      this.shown = true
    },
    memberRateDisplayTotal (member) {
      return (member?.membershipMonthlyRate || 0) * this.membershipPeriod
    }
  }

}
</script>
